import router from '@/router'
import { toast } from './toast.js'

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  };
}

export const log = {
  error: console.error,
  warn: console.warn,
  info: console.log,
  trace: console.trace,
  debug: console.debug,
  time: console.time,
  timeEnd: console.timeEnd,
};

let host  = window.host;

export const HostName  = host;


/**
 * Глобальные константы
 */
export const g_config = {
    urlLogin: host + 'medcenter/login',
    urlLogOut: host + 'logout',
    
    urlPasswordChange: host + 'password/change',
    urlPasswordSendEmail: host + 'password/send-email/',
    urlGetResearches: host + 'medcenter/get-researches',
};

export const mobileAndTabletCheck = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

/**
 * Обработка ошибки апи, которую вернул сам сервер, в json ответа
 */
export const apiErrorHandling = (data) => {
    console.log(data);

    if(data.error_key == "unauthorized")
    { 
        toast.toast( { type: 'text', value: "Пользователь не авторизован" }, { settings: { duration: 5300 } });
        router.push('/login');
        return;
    }
    
    toast.toast(
        {
            type: 'text',
            value: data.message
        }, {
            settings: {
            duration: 5300,
        }
    });
};

/**
 * Обработка ошибки запроса к апи
 */
const errorResponseHandling = (err, method, url, text, request_data = {}) => {
    
    //console.log(err, '-', err.name, '-', err.message, method, url, data);
    
    let printMessage = "Ошибка обработки запроса";
    
    if (err instanceof TypeError) {
        if(err.message.indexOf("NetworkError") != -1) {
            printMessage = "Ошибка сети";
        }
    }
    else if (err instanceof SyntaxError) {
        
        fetch(g_config.urlSendError, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=utf-8',
              'Authorization': 'Bearer ' + localStorage.token,
              'pragma': 'no-cache',
              'cache-control': 'no-cache',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({
                type: method,
                url: url,
                data:     navigator.userAgent 
                        + ' \n' + window.location 
                        + ' \n' + JSON.stringify(request_data) 
                        + ' \n' + text
            })
        });
    }

    toast.toast(
        {
            type: 'text',
            value: printMessage
        }, {
            settings: {
            duration: 5300,
        }
    });
};

/**
 * Запрос POST
 * 
 * @param {type} url
 * @param {type} request_data
 * @param {type} x_csrf_token
 * @returns {unresolved}
 */
export const g_postRequest = async (url = '', request_data = {}, token = '') => {
    
    let text = '';
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=utf-8',
              'Authorization': 'Bearer ' + token,
              'pragma': 'no-cache',
              'cache-control': 'no-cache',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(request_data)
        });
    
        text = await response.text(); // Parse it as text
        const data = JSON.parse(text); // Try to parse it as json
        
        if(data.success === false) {
            apiErrorHandling(data);
            return Promise.reject({type_error: 'api', data: data});
        }
        
        return data;
    }
    catch(err) {
        errorResponseHandling(err, 'POST', url, text, request_data);
        return Promise.reject({type_error: 'other', data: err});
    }
};

/**
 * Запрос POST
 * 
 * @param {type} url
 * @param {type} request_data  (new FormData())
 * @param {type} x_csrf_token
 * @returns {unresolved}
 */
export const g_postRequest2 = async (url = '', request_data, token) => {
    
    let text = '';
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Authorization': 'Bearer ' + token,
              'pragma': 'no-cache',
              'cache-control': 'no-cache',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: request_data
        });
    
        text = await response.text(); // Parse it as text
        const data = JSON.parse(text); // Try to parse it as json
        
        if(data.success === false) {
            apiErrorHandling(data);
            return Promise.reject({type_error: 'api', data: data});
        }
        
        return data;
    }
    catch(err) {
        errorResponseHandling(err, 'POST', url, text, request_data);
        return Promise.reject({type_error: 'other', data: err});
    }
};

/**
 * Запрос PUT
 * 
 * @param {type} url
 * @param {type} request_data
 * @param {type} x_csrf_token
 * @returns {unresolved}
 */
export const g_putRequest = async (url = '', request_data = {}, token = '') => {
    
    let text = '';
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=utf-8',
              'Authorization': 'Bearer ' + token,
              'pragma': 'no-cache',
              'cache-control': 'no-cache',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(request_data)
        });
    
        text = await response.text(); // Parse it as text
        const data = JSON.parse(text); // Try to parse it as json
        
        if(data.success === false) {
            apiErrorHandling(data);
            return Promise.reject({type_error: 'api', data: data});
        }
        
        return data;
    }
    catch(err) {
        errorResponseHandling(err, 'PUT', url, text, request_data);
        return Promise.reject({type_error: 'other', data: err});
    }
};

/**
 * Запрос GET
 * 
 * @param {type} url
 * @param {type} token
 * @returns {unresolved}
 */
export const g_getRequest = async (url = '', token = '') => {
    
    let text = '';
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=utf-8',
              'Authorization': 'Bearer ' + token,
              'pragma': 'no-cache',
              'cache-control': 'no-cache',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer'
        });
        
        text = await response.text(); // Parse it as text
        const data = JSON.parse(text); // Try to parse it as json
        
        if(data.success === false) {
            apiErrorHandling(data);
            return Promise.reject({type_error: 'api', data: data});
        }
        
        return data;
    }
    catch(err) {
        errorResponseHandling(err, 'GET', url, text);
        return Promise.reject({type_error: 'other', data: err});
    }
};

/**
 * Запрос DELETE
 * 
 * @param {type} url
 * @param {type} token
 * @returns {unresolved}
 */
export const g_deleteRequest = async (url = '', request_data = {}, token = '') => {
    
    let text = '';
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=utf-8',
              'Authorization': 'Bearer ' + token,
              'pragma': 'no-cache',
              'cache-control': 'no-cache',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify(request_data)
        });
    
        text = await response.text(); // Parse it as text
        const data = JSON.parse(text); // Try to parse it as json
        
        if(data.success === false) {
            apiErrorHandling(data);
            return Promise.reject({type_error: 'api', data: data});
        }
        
        return data;
    }
    catch(err) {
        errorResponseHandling(err, 'DELETE', url, text, request_data);
        return Promise.reject({type_error: 'other', data: err});
    }
};

/**
 * @example getCorrectSuffix(10, "день","дня", "дней")
 */
export const getCorrectSuffix = (num, str1, str2, str3) => {
    var val = num % 100;
    
    if (val > 10 && val < 20)
    {
      return str3;
    }
    else
    {
      val = num % 10;
      if (val == 1)
      { return str1; }	    
      else if (val > 1 && val < 5)
      { return str2; }
      else
      { return str3; }
    }
}

export const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const truncString = (str, max, add) => {
    add = add || '...';
    return (typeof str === 'string' && str.length > max ? str.substring(0,max)+add : str);
}

export const dateToString = (a) => {
    let year = a.getFullYear();
    let month = '' + (a.getMonth() + 1);
    let date = '' + a.getDate();

    if (month.length < 2) month = '0' + month;
    if (date.length < 2)  date = '0' + date;

    return date + '.' + month + '.' + year;
}

/**
 * 
 * @param {type} string date dd.mm.yyyy
 * @returns {Date}
 */
export const strToDate = (strdate) => {
    let dateParts = strdate.split(".");
    return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
}


/**
* Convert timestatm to date format hour:min
* 
* @param {type} UNIX_timestamp
* @returns {string}
*/
export const timeConverterGetTime = (UNIX_timestamp) => {
   let a = new Date(UNIX_timestamp * 1000);
   let hour = '' + a.getHours();
   let min = '' + a.getMinutes();

   if (hour.length < 2)  hour = '0' + hour;
   if (min.length < 2)   min = '0' + min;

   return hour + ':' + min;
}
/**
* Convert timestatm to date format dd.mm.YYYY
* 
* @param {type} UNIX_timestamp
* @returns {string}
*/
export const timeConverterGetDate = (UNIX_timestamp) => {
   let a = new Date(UNIX_timestamp * 1000);
   let year = a.getFullYear();
   let month = '' + (a.getMonth() + 1);
   let date = '' + a.getDate();

   if (month.length < 2) month = '0' + month;
   if (date.length < 2)  date = '0' + date;

   return date + '.' + month + '.' + year;
}